import moment from "moment";

export default {
  "bewerber.anrede": ({ applicant }) => {
    if (applicant.salutation == "MRS") {
      return "Sehr geehrte Frau";
    } else if (applicant.salutation == "MR") {
      return "Sehr geehrter Herr";
    } else {
      return "Guten Tag,";
    }
  },
  "bewerber.vorname": ({ applicant }) => applicant.firstName,
  "bewerber.nachname": ({ applicant }) => applicant.lastName,
  "bewerber.plz": ({ applicant }) => applicant.contactData.address.zip,
  "bewerber.ort": ({ applicant }) => applicant.contactData.address.city,
  "bewerber.strasse": ({ applicant }) => applicant.contactData.address.street,
  "bewerber.telefon": ({ applicant }) => applicant.contactData.telephone,
  "bewerber.mobil": ({ applicant }) => applicant.contactData.telephoneMobile,
  "bewerber.mail": ({ applicant }) => applicant.contactData.email,
  "bewerber.beworben_am": ({ applicant }) => applicant.createdAt,
  datum: () => moment().format("DD.MM.YYYY"),
  "berater.vorname": ({ consultant }) => consultant.firstName,
  "berater.nachname": ({ consultant }) => consultant.lastName,
  "berater.position": ({ consultant }) => consultant.position,
  "berater.telefon": ({ consultant }) => consultant.telephone,
  "berater.telefonbuero": ({ consultant }) => consultant.telephoneOffice,
  "berater.fax": ({ consultant }) => consultant.fax,
  "berater.plz": ({ consultant }) => consultant.zip,
  "berater.ort": ({ consultant }) => consultant.city,
  "berater.strasse": ({ consultant }) => consultant.street,
  "berater.mail": ({ user }) => user.email
};
